import { render, staticRenderFns } from "./SettingEmpty.vue?vue&type=template&id=7d5180bf&scoped=true&"
import script from "./SettingEmpty.vue?vue&type=script&lang=js&"
export * from "./SettingEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SettingEmpty.vue?vue&type=style&index=0&id=7d5180bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5180bf",
  null
  
)

export default component.exports